/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_Filter_Amount_PlaceholderInputs */

const vi_list_filter_amount_placeholder = /** @type {(inputs: List_Filter_Amount_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập giá trị`)
};

/**

* @param {List_Filter_Amount_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const list_filter_amount_placeholder = /** @type {((inputs?: List_Filter_Amount_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Filter_Amount_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_list_filter_amount_placeholder(inputs)
});